import * as dicomParser from 'dicom-parser';
import pako from 'pako';
function inflater(byteArray, position) {
    const deflated = byteArray.slice(position);
    const inflated = pako.inflateRaw(deflated);
    const fullByteArray = new Uint8Array(inflated.length + position);
    fullByteArray.set(byteArray.slice(0, position), 0);
    fullByteArray.set(inflated, position);
    return fullByteArray;
}
export const parseDicomOptions = { inflater };
export function parseDicom(byteArray, options) {
    return dicomParser.parseDicom(byteArray, {
        ...parseDicomOptions,
        ...options,
    });
}
